import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Button, Badge, Label } from 'react-bootstrap';
import { displayBuyerBidState } from '../../../core/api';

import ProposalTable from './ProposalTable';
import ProposalSendMenu from './ProposalSendMenu';

class ProposalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: true,
    };
    this.toggleBox = this.toggleBox.bind(this);
  }
  toggleBox() {
    // check if box is currently opened
    const { opened } = this.state;
    this.setState({
      // toggle value of `opened`
      opened: !opened,
    });
  }
  render() {
    let name = 'Unbranded';
    if (this.props.proposal.brand) {
      name = this.props.proposal.brand.name;
    }
    const bids = this.props.proposal.bids;
    const status = {};
    status.sent = 0;
    status.pending = 0;
    for (let i = 0, len = bids.length; i < len; i++) {
      if(bids[i].bidset){
        const displayState = displayBuyerBidState(bids[i].buyer_state, bids[i].bidder_state);
        if (['Sent', 'Sending'].includes(displayState)) {
          status.sent += 1;
        }
        if (['Draft'].includes(displayState)) {
          status.pending += 1;
        }
      }
    }
    //debugger;
    const { opened } = this.state;
    return (
      <div className="panel proposal-header" key={this.props.proposal.id}>
        <h3>
          <i
            className={opened ? 'fa fa-minus-square' : 'fa fa-plus-square'}
            aria-hidden="true"
            onClick={this.toggleBox}
          />&nbsp;&nbsp;
          {name}&nbsp;&nbsp;
          {status.pending !== 0 && <Badge bsStyle="info">{status.pending}</Badge>}
        </h3>
        {opened && (
          <div>
            <ProposalSendMenu
              proposal={this.props.proposal}
              sendProposal={this.props.sendProposal}
              status={status}
              addHotelContact={this.props.addHotelContact}
              addBrandContact={this.props.addBrandContact}
              sendHotelBidRequests={this.props.sendHotelBidRequests}
              HotelContactDelete={this.props.HotelContactDelete}
              HotelContactUpdate={this.props.HotelContactUpdate}
              HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
              HotelBrandContactDelete={this.props.HotelBrandContactDelete}
            />
            <ProposalTable
              proposal={this.props.proposal}
              editBid={this.props.editBid}
              addBidNote={this.props.addBidNote}
              sendBid={this.props.sendBid}
              removeBid={this.props.removeBid}
              user={this.props.user}
              tourData={this.props.tourData}
              editMember={this.props.editMember}
              requestBidDetails={this.props.requestBidDetails}
              bidbidsDetails={this.props.bidbidsDetails}
            />
          </div>
        )}
      </div>
    );
  }
}

ProposalDetail.propTypes = {
  proposal: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  sendProposal: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
};

export default ProposalDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalDetail.js